<template>
  <div class="mail-box-header">
    <table class="table table-hover table-mail">
      <thead class="table-head">
        <tr>
          <th>Valor</th>
          <th>Descrição</th>
          <th>Data de criação</th>
          <th>Usuário</th>
        </tr>
      </thead>

      <tbody class="table-list">
        <tr v-for="(moviment, listIdx) in cashMovement" :key="listIdx">
          <td>{{ totalToCurrencyBR(moviment.amount) }}</td>
          <td>{{ moviment.description }}</td>
          <td>{{ DateBR(moviment.createdAt) }}</td>
          <td>{{ moviment.userInteract.fullName }}</td>
        </tr>
      </tbody>
    </table>
    <div class="form-group">
      <span class="label label-success pull-right"
        >Total: {{ totalToCurrencyBR(total) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cashMovement: {
      default: Array,
    },
  },

  computed: {
    total() {
      const total = this.cashMovement.reduce(
        (acc, item) => acc + item.amount,
        0,
      );
      return total;
    },
  },
  methods: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      return new Date(dt).toLocaleString('pt-br');
    },
  },
};
</script>